module.exports = __webpack_public_path__ + "static/media/fun-printing.8b80440.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fun-printing.mp4
// module id = gth6
// module chunks = 1